import { render, staticRenderFns } from "./AddCardHeader.vue?vue&type=template&id=3099c7e3&scoped=true&"
import script from "./AddCardHeader.vue?vue&type=script&lang=js&"
export * from "./AddCardHeader.vue?vue&type=script&lang=js&"
import style0 from "./AddCardHeader.vue?vue&type=style&index=0&id=3099c7e3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3099c7e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VFlex,VIcon,VImg,VLayout})
